/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconEditFilled8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEditFilled8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M5.982 1.712a4.5 4.5 0 0 1 .801 1.085l.613-.614c.33-.33.543-.872-.235-1.65-.778-.777-1.32-.565-1.65-.235L4.898.91l.001.001c.39.205.755.472 1.083.8Zm-3.025 4.91 3.075-3.074a3.49 3.49 0 0 0-.757-1.13 3.49 3.49 0 0 0-1.129-.756L1.071 4.737c-.163.164-.29.359-.374.574L.034 7.013a.5.5 0 0 0 .648.647l1.701-.662c.215-.084.41-.212.574-.375Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconEditFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEditFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M8.973 2.568a6.748 6.748 0 0 1 1.202 1.627l.92-.92c.495-.495.813-1.308-.354-2.475C9.574-.367 8.761-.049 8.266.446l-.92.92.003.002a6.748 6.748 0 0 1 1.624 1.2ZM4.435 9.934l4.613-4.612a5.234 5.234 0 0 0-1.135-1.694c-.501-.5-1.078-.879-1.693-1.135L1.607 7.106a2.5 2.5 0 0 0-.562.86L.05 10.52a.75.75 0 0 0 .971.97l2.552-.993a2.5 2.5 0 0 0 .861-.562Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconEditFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEditFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M12.973 2.568a6.747 6.747 0 0 1 1.202 1.627l.92-.92c.495-.495.813-1.308-.354-2.475-1.167-1.167-1.98-.849-2.475-.354l-.92.92.003.002a6.746 6.746 0 0 1 1.624 1.2ZM4.435 13.934l8.613-8.612a5.235 5.235 0 0 0-1.135-1.694c-.501-.5-1.078-.879-1.693-1.135l-8.613 8.613a2.5 2.5 0 0 0-.562.86L.05 14.52a.75.75 0 0 0 .971.97l2.552-.993a2.5 2.5 0 0 0 .861-.562Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconEditFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEditFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m3.91 16.104-1.314 3.504a.75.75 0 0 0 .965.965l3.504-1.314a3 3 0 0 0 1.068-.687L18.28 8.425s-.354-1.061-1.415-2.122c-1.06-1.06-2.12-1.414-2.12-1.414L4.596 15.036a3 3 0 0 0-.688 1.068Zm12.248-12.63 1.384-1.383c.248-.248.579-.406.925-.348.486.08 1.231.322 1.934 1.025.703.703.945 1.447 1.025 1.934.058.346-.1.677-.348.925L19.694 7.01s-.354-1.06-1.414-2.12c-1.06-1.062-2.122-1.415-2.122-1.415Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconEditFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEditFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconEditFilled8 {...iconProps} />;
        case '12':
            return <IconEditFilled12 {...iconProps} />;
        case '16':
            return <IconEditFilled16 {...iconProps} />;
        case '24':
            return <IconEditFilled24 {...iconProps} />;
        default:
            return <IconEditFilled24 {...iconProps} />;
    }
});
